(function () {
  var pending = null;
  var selector = '.ocu-sidebar-filter input[type="checkbox"]';
  function activate(input) {
    var label = input.labels && input.labels[0];
    if (!label) return;
    pending = { input: input, id: input.id };
    label.click();
  }
  document.addEventListener('keydown', function (event) {
    if (event.target.matches(selector) && (event.key === ' ' || event.key === 'Enter')) {
      event.preventDefault();
      if (!event.repeat) activate(event.target);
    }
  });
  document.addEventListener('click', function (event) {
    if (event.target.matches(selector)) {
      event.preventDefault();
      activate(event.target);
    }
  });
  document.addEventListener('focusin', function (event) {
    if (pending && event.target !== pending.input && !event.target.matches(selector)) pending = null;
  });
  new MutationObserver(function () {
    if (!pending || pending.input.isConnected) return;
    var replacement = document.getElementById(pending.id);
    if (replacement && replacement.matches(selector)) {
      pending = null;
      replacement.focus({ preventScroll: true });
    }
  }).observe(document.body, { childList: true, subtree: true });
})();